let data76;
if (typeof window === "undefined") {
  data76 = require("../static-s76/Data.json");
} else {
  // data76 = require("../static-s76/Data.json");
  // window.data76 = data76;
  data76 = window.data76;
}

export { data76 };
